module.exports = __webpack_public_path__ + "static/media/Prince-news.c75cc12d.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/Prince-news.png
// module id = 70
// module chunks = 0